require('../../modules/es6.object.get-prototype-of');
module.exports = require('../../modules/_core').Object.getPrototypeOf;



//////////////////
// WEBPACK FOOTER
// ./~/material-ui/~/core-js/library/fn/object/get-prototype-of.js
// module id = 961
// module chunks = 0 1